import { PowerUpsContainer } from "../scenes/PowerUpsContainer";
import { GUI } from "./GUI";
import { ReusableMenuBackground } from "../scenes/ReusableMenuBackground";
import { GameVars } from "../GameVars";
import { GameConstants } from "../GameConstants";
import { AudioManager, SoundTrack } from "../AudioManager";
import { AudioButtonsContainer } from "../scenes/AudioButtonsContainer";
import { CheatMenu } from "./CheatMenu";
import { GameManager } from "../GameManager";

export class PauseMenu extends Phaser.Group {

    public static currentInstance: PauseMenu;

    public powerUpsContainer: PowerUpsContainer;

    private levelSelectionButton: Phaser.Button;
    private resumeButton: Phaser.Button;
    private gui: GUI;
    private scaledItemsContainer: Phaser.Group;
    private reusableMenuBackground: ReusableMenuBackground;

    constructor(game: Phaser.Game, gui: GUI) {

        super(game, null, "pause-menu", false);

        PauseMenu.currentInstance = this;

        this.gui = gui;

        const transparentLayer = new Phaser.Sprite(this.game, 0, 0, this.game.cache.getBitmapData("green_square"));
        transparentLayer.scale.setTo(48, 64);
        transparentLayer.alpha = .85;
        this.add(transparentLayer);

        this.scaledItemsContainer = new Phaser.Group(this.game);
        this.scaledItemsContainer.scale.y = GameVars.scaleY;
        this.scaledItemsContainer.y = (1 - GameVars.scaleY) * GameConstants.GAME_HEIGHT * .5;
        this.add(this.scaledItemsContainer);

        this.reusableMenuBackground = new ReusableMenuBackground(this.game, ReusableMenuBackground.PAUSE_LAYER);
        this.scaledItemsContainer.add(this.reusableMenuBackground);

        this.powerUpsContainer = new PowerUpsContainer(this.game, false);
        this.powerUpsContainer.y = 490;
        this.scaledItemsContainer.add(this.powerUpsContainer);

        this.addButtons();
    }

    public destroy(destroyChildren?: boolean, soft?: boolean): void {

        PauseMenu.currentInstance = null;

        super.destroy(destroyChildren, soft);
    }

    public show(): void {

        this.reusableMenuBackground.updateScoreLabelOnPauseMenu();
        this.visible = true;
    }

    public hide(): void {

        this.visible = false;
    }

    public onClickResume(): void {

        if (GameVars.isTimedLevel) {
            this.game.time.events.resume();
        }

        this.gui.hideMenuContainer();

        AudioManager.getInstance().playEffect("play");
        AudioManager.getInstance().setVolumePlayingMusic(1);
    }

    private addButtons(): void {

        // botones
        this.levelSelectionButton = new Phaser.Button(this.game, 15, 865, "texture_atlas_5", this.onClickLevelSelection, this);
        this.levelSelectionButton.setFrames("exit_button_on", "exit_button_off", "exit_button_on");
        this.levelSelectionButton.forceOut = true;
        this.levelSelectionButton.scale.y = GameVars.scaleY;
        this.add(this.levelSelectionButton);

        const resetButton = new Phaser.Button(this.game, 364, 930, "texture_atlas_5", this.onClickReset, this);
        resetButton.setFrames("reset_button_on", "reset_button_off", "reset_button_on");
        resetButton.anchor.setTo(.5);
        resetButton.scale.y = GameVars.scaleY;
        this.add(resetButton);

        this.resumeButton = new Phaser.Button(this.game, 675, 920, "texture_atlas_5", this.onClickResume, this);
        this.resumeButton.setFrames("resume_button_on", "resume_button_off", "resume_button_on");
        this.resumeButton.anchor.set(.5);
        this.resumeButton.forceOut = true;
        this.resumeButton.scale.y = GameVars.scaleY;
        this.add(this.resumeButton);

        const pulseTween = this.game.add.tween(this.resumeButton.scale);
        pulseTween.to({ x: 1.05, y: .95 * GameVars.scaleY }, 300, Phaser.Easing.Linear.None, false);
        pulseTween.delay(50);
        pulseTween.to({ x: .95, y: 1.05 * GameVars.scaleY }, 700, Phaser.Easing.Elastic.Out);
        pulseTween.loop();
        pulseTween.start();

        // los botones de audio
        const audioButtons = new AudioButtonsContainer(this.game, new Phaser.Point(615, 10), new Phaser.Point(675, 10));
        this.scaledItemsContainer.add(audioButtons);

        if (GameConstants.DEVELOPMENT && !GameVars.penalties) {
            const cheatMenu = new CheatMenu(this.game);
            this.add(cheatMenu);
        }
    }

    private onClickLevelSelection(): void {

        if (GameVars.isTimedLevel) {
            this.game.time.events.resume();
        }

        if (GameVars.levelEdition) {
            this.game.state.start("DevelopmentLevelSelection", true, false);
        } else {
            this.game.state.start("TrophyState", true, false);
        }

        AudioManager.getInstance().playEffect("play");
        AudioManager.getInstance().setVolumePlayingMusic(1);

        if (GameVars.isTimedLevel) {
            AudioManager.getInstance().stopMusic(SoundTrack.EXTRA_TIME);
        } else {
            AudioManager.getInstance().stopMusic(SoundTrack.GAME_SOUNDTRACK);
        }
    }

    private onClickReset(): void {

        GameManager.onMatchReplayed();

        if (GameVars.isTimedLevel) {
            this.game.time.events.resume();
        }

        AudioManager.getInstance().playEffect("play");
        AudioManager.getInstance().setVolumePlayingMusic(1);

        if (GameVars.isTimedLevel) {
            AudioManager.getInstance().stopMusic(SoundTrack.EXTRA_TIME);
        } else {
            AudioManager.getInstance().stopMusic(SoundTrack.GAME_SOUNDTRACK);
        }

        this.game.state.start("FootballFieldState", true, false);
    }
}
